declare const window: { dataLayer: object[] };

type GTMEvent =
  | {
      event: "contact_form_submit";
      currency: "EUR";
      value: number;
    }
  | {
      event: "apply_form_submit";
    };

export const usePushGtmEvent = () => (event: GTMEvent) => {
  window.dataLayer?.push(event);
};
